import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton } from '@mui/material';

import useToggleState from '~/hooks/useToggleState';

import BusinessServiceFeesCreateEditModal from './BusinessServiceFeesCreateEditModal';
import BusinessServiceFeesDeleteModal from './BusinessServiceFeesDeleteModal';

interface Props {
  serviceFee: App.BusinessServiceFee;
  onSuccess: () => void;
}

export default function ServiceFeeGridActions({ serviceFee, onSuccess }: Props) {
  const { isToggled: isEditDialogOpen, toggleOn: openEditDialog, toggleOff: closeEditDialog } = useToggleState();
  const { isToggled: isDeleteDialogOpen, toggleOn: openDeleteDialog, toggleOff: closeDeleteDialog } = useToggleState();

  return (
    <>
      <IconButton onClick={openEditDialog}>
        <EditIcon />
      </IconButton>
      <IconButton onClick={openDeleteDialog}>
        <DeleteIcon />
      </IconButton>
      <BusinessServiceFeesCreateEditModal
        businessId={serviceFee.businessId}
        serviceFee={serviceFee}
        isOpen={isEditDialogOpen}
        onSuccess={onSuccess}
        onClose={closeEditDialog}
        mode="edit"
      />
      <BusinessServiceFeesDeleteModal
        businessId={serviceFee.businessId}
        serviceFeeId={serviceFee.id}
        isOpen={isDeleteDialogOpen}
        onSuccess={onSuccess}
        onClose={closeDeleteDialog}
      />
    </>
  );
}
